import Vue from 'vue'

Vue.filter('groupValue', function({ type, values }) {
    return type == 'range' ? `${values[0]} - ${values[1]}` : values[0]
})
